/** The slice of i18next's `t` this needs; keeps the helper trivially testable with no casts. */
export type Translate = (key: string) => string;

/**
 * Localized, calm copy for the outdated-extension nudge (ext_update_2026q4, namespace `common`).
 * The server copy (a remove/reinstall essay, English only) is deliberately NOT used: the banner
 * shows one short line and one action, in the user's language. Keys are string literals so the
 * translation-keys-exist gate can see them.
 */
export function extUpdateCopy(t: Translate): { headline: string; cta: string; dismiss: string } {
  return {
    headline: t('extUpdateNudge.headline'),
    cta: t('extUpdateNudge.cta'),
    dismiss: t('extUpdateNudge.dismiss'),
  };
}
